import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Student } from '@/types/models';
import StudentsSection from '../sidebar/StudentsSection';
import StudentsTabHeader from './components/StudentsTabHeader';
import EditStudentDialog from '@/components/students/EditStudentDialog';
import { toast } from 'sonner';

interface FamilyStudentsTabProps {
  students: Student[];
  onAddStudent: () => void;
  onEditStudent?: (student: Student) => void;
}

const FamilyStudentsTab = ({
  students,
  onAddStudent,
  onEditStudent
}: FamilyStudentsTabProps) => {
  const [editingStudent, setEditingStudent] = useState<Student | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  
  // Direct and simple handler for editing students
  const handleEditStudent = (student: Student) => {
    console.log("FamilyStudentsTab DIRECT: Edit student:", student.id);
    if (onEditStudent) {
      // Use parent's handler if available
      onEditStudent(student);
    } else {
      // Otherwise use local dialog
      setEditingStudent(student);
      setIsEditDialogOpen(true);
    }
  };

  const handleStudentUpdated = (updatedStudent: Student) => {
    toast.success(`${updatedStudent.first_name} ${updatedStudent.last_name} updated successfully`);
    setIsEditDialogOpen(false);
    setEditingStudent(null);
  };

  return (
    <>
      <Card>
        <StudentsTabHeader onAddStudent={onAddStudent} />
        <CardContent>
          <StudentsSection
            students={students}
            onAddStudent={onAddStudent}
            onEditStudent={handleEditStudent}
            expanded
          />
        </CardContent>
      </Card>

      {/* Only show dialog if we're handling editing locally */}
      {!onEditStudent && editingStudent && (
        <EditStudentDialog
          student={editingStudent}
          open={isEditDialogOpen}
          onOpenChange={setIsEditDialogOpen}
          onUpdated={handleStudentUpdated}
        />
      )}
    </>
  );
};

export default FamilyStudentsTab;
